import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "border-System/app_border rounded-sm border-[1px] border-solid h-full flex flex-col justify-between" }
const _hoisted_3 = { class: "px-[32px] pt-[32px]" }
const _hoisted_4 = {
  "data-testid": "personal-info--title",
  class: "text-Text/text_high gordita-medium-500-16 pb-6"
}
const _hoisted_5 = { class: "grid gap-[40px]" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1)

import { IncrediField, IncrediButton, IncrediForm, useIncrediForm } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { watch } from 'vue';
import { useUser_UpdatePersonalInfoMutation, useUserQuery } from '@/graphql/codegen/generated/graphql';
import { useNotify } from '@/services/notify/notify';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { useI18n } from 'vue-i18n';
import { validateAllWhiteSpaces, validateEmail } from '@/utils/string-validations';


export default /*#__PURE__*/_defineComponent({
  __name: 'personalInfoTab',
  setup(__props) {

const { t } = useI18n();
const { toastMessage } = useNotify();
const GQL_updatePersonalInfo = useUser_UpdatePersonalInfoMutation({});
const GQL_userInfo = useUserQuery({
  fetchPolicy: 'network-only',
});

const { fields, form } = useIncrediForm({
  initialValues: {
    firstName: '',
    lastName: '',
    email: '',
  },
  validationSchema: {
    firstName: (value: string) => {
      if (validateAllWhiteSpaces(value)) return t('userProfile.personalInfoTab.invalid');
      return true;
    },
    lastName: (value: string) => {
      if (validateAllWhiteSpaces(value)) return t('userProfile.personalInfoTab.invalid');
      return true;
    },
    email: (value: string) => value === '' || validateEmail(value) || t('userProfile.personalInfoTab.emailFormatValidation'),
  },
});
watch(GQL_userInfo.result, val => {
  if (val?.user) {
    form.resetForm({
      values: {
        firstName: val.user.additionalInfo?.firstName || '',
        lastName: val.user.additionalInfo?.lastName || '',
        email: val.user.additionalInfo?.email || '',
      },
    });
  }
});

const saveChanges = form.handleSubmit(async () => {
  try {
    await GQL_updatePersonalInfo.mutate({
      data: {
        firstName: fields.firstName.value.value,
        lastName: fields.lastName.value.value,
        email: fields.email.value.value.length > 0 ? fields.email.value.value : null,
      },
    });
    toastMessage(t('userProfile.personalInfoTab.successToastText'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
    GQL_userInfo.refetch();
  } catch (error) {
    toastMessage(t('userProfile.failureToastText'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "h-full" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IncrediForm), {
          class: "h-full",
          onSubmit: _unref(saveChanges),
          onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('userProfile.personalInfoTab.title')), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(IncrediField), {
                    modelValue: _unref(fields).firstName.value.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(fields).firstName.value.value) = $event)),
                    "data-testid": "personal-info--first-name-input",
                    class: "input-field",
                    autocomplete: "off",
                    size: "big",
                    label: "First Name (Optional)",
                    "field-type": "text",
                    error: !!_unref(form).errors.value.firstName,
                    "error-message": _unref(form).errors.value.firstName,
                    maxlength: 30,
                    onChange: _cache[1] || (_cache[1] = () => _unref(fields).firstName.validate())
                  }, null, 8, ["modelValue", "error", "error-message"]),
                  _createVNode(_unref(IncrediField), {
                    modelValue: _unref(fields).lastName.value.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(fields).lastName.value.value) = $event)),
                    "data-testid": "personal-info--last-name-input",
                    class: "input-field",
                    autocomplete: "off",
                    size: "big",
                    label: "Last Name (Optional)",
                    "field-type": "text",
                    error: !!_unref(form).errors.value.lastName,
                    "error-message": _unref(form).errors.value.lastName,
                    maxlength: 30,
                    onChange: _cache[3] || (_cache[3] = () => _unref(fields).lastName.validate())
                  }, null, 8, ["modelValue", "error", "error-message"]),
                  _createVNode(_unref(IncrediField), {
                    modelValue: _unref(fields).email.value.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(fields).email.value.value) = $event)),
                    "data-testid": "personal-info--email-input",
                    class: "input-field",
                    autocomplete: "off",
                    size: "big",
                    label: "Email (Optional)",
                    "field-type": "text",
                    error: !!_unref(form).errors.value.email,
                    "error-message": _unref(form).errors.value.email,
                    onChange: _cache[5] || (_cache[5] = () => _unref(fields).email.validate())
                  }, null, 8, ["modelValue", "error", "error-message"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_unref(IncrediButton), {
                  "data-testid": "personal-info--save-button",
                  type: "submit",
                  class: "flex flex-row justify-end items-end px-[24px] py-[10px] mb-0",
                  design: "primary-green",
                  size: "big",
                  disabled: !_unref(form).meta.value.dirty,
                  onKeydown: _withKeys(_withModifiers(_unref(saveChanges), ["prevent"]), ["enter"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('userProfile.saveBtn')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onKeydown"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    _: 1
  }))
}
}

})